<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a id="home_btn" [routerLink]="['/home']" class="nav-link">Home</a>
        </li>
        <li class="nav-item">
          <a
            id="claims_btn"
            [routerLink]="['/claims']"
            class="nav-link"
            role="button"
            >Claims</a
          >
        </li>
        <li class="nav-item">
          @if (!signedInDisplay) {
          <a
            id="sign_up_in_pkce_btn"
            role="button"
            (click)="login()"
            class="nav-link"
            >Sign In/Register</a
          >
          }
        </li>
        <li class="nav-item">
          @if (signedInDisplay) {
          <a
            id="sign_out_btn"
            role="button"
            (click)="platform_identity_logout()"
            class="nav-link"
            >Sign Out</a
          >
          }
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="container">
  <div class="row">
    <router-outlet></router-outlet>
  </div>

  <div class="row">
    <router-outlet name="aux"></router-outlet>
  </div>
</div>
